import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';

import { ProviderEndpointsComponent } from './provider-endpoints.component';
import { AvatarModule } from '../../components/avatar/avatar.module';
import { ListingModule } from '../../components/listing/listing.module';
import { DirectivesModule } from '../../directives/directive.module';
import { HelpTooltipModule } from '../../components/helpTooltip/helpTooltip.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { EditProviderEndpointDialogModule } from '../../components/edit-provider-endpoint-dialog/edit-provider-endpoint-dialog.module';
import { DocumentsDialogModule } from '../../components/documents/documents-dialog.module';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DocumentsDialogModule,
        EditProviderEndpointDialogModule,
        MatButtonModule,
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        MatPaginatorModule,
        MatFormFieldModule,
        InfiniteScrollModule,
        AvatarModule,
        MatDialogModule,
        ListingModule,
        DirectivesModule,
        HelpTooltipModule
    ],
    declarations: [
        ProviderEndpointsComponent,
    ],
    exports: [
        ProviderEndpointsComponent
    ]
})
export class ProviderEndpointsModule { }
